import React from 'react';
import { PillRow } from './PillRow';
import { usePlatform } from '../contexts/PlatformContext';
import { pills } from '../data/pills';
import { getFlaggedIds, getRecommendedPillIds } from '../utils/pack';
export function LongevityPackBuilder() {
  const {
    panel,
    customPillIds,
    togglePill
  } = usePlatform();
  const flagged = getFlaggedIds(panel);
  const recommendedIds = getRecommendedPillIds(panel);
  const nameOf = (id: string) => panel.find(b => b.id === id)?.name ?? id;
  const recommended = pills.filter(p => recommendedIds.includes(p.id));
  const extras = pills.filter(p => p.goals.includes('longevity') && !recommendedIds.includes(p.id));
  return <div className="space-y-10" data-id="element-69" data-mp="e3domtt98ncf">
      <section aria-labelledby="rec-heading" data-id="element-70" data-mp="e3ni4rdidcmv">
        <h2 id="rec-heading" className="text-lg font-medium" data-id="element-71" data-mp="e1azsd3u909a">Recommended from your biomarkers</h2>
        <p className="mt-1 text-sm text-muted-foreground" data-id="element-72" data-mp="2axqnv92abuhw">
          Matched to {flagged.length} markers outside range. Remove anything you don't want.
        </p>
        <ul className="mt-5 space-y-2" data-id="element-73" data-mp="2rk7sohbai8lu">
          {recommended.map(pill => <PillRow key={pill.id} pill={pill} showPrice reasons={pill.targets.filter(t => flagged.includes(t)).map(nameOf)} inPack={customPillIds.includes(pill.id)} onToggle={() => togglePill(pill.id)} data-id="element-74" data-mp="2ms6ayfvcrpof" />)}
        </ul>
      </section>

      <section aria-labelledby="extra-heading" data-id="element-75" data-mp="3ah90sb054ou0">
        <h2 id="extra-heading" className="text-lg font-medium" data-id="element-76" data-mp="35ifqerg5hdy2">Add to your pack</h2>
        <p className="mt-1 text-sm text-muted-foreground" data-id="element-77" data-mp="30jkvir4wryxl">
          Optional additions for performance, longevity and wellbeing goals. Reviewed by your doctor before packing.
        </p>
        <ul className="mt-5 space-y-2" data-id="element-78" data-mp="1p4pif9lwu5j5">
          {extras.map(pill => <PillRow key={pill.id} pill={pill} showPrice inPack={customPillIds.includes(pill.id)} onToggle={() => togglePill(pill.id)} data-id="element-79" data-mp="1p60iozg5cv5i" />)}
        </ul>
      </section>
    </div>;
}